import { useMemo } from 'react';
import { useGetHasScope } from '../../auth/hooks/useGetHasScope';
import { useGetIsUngated } from '../../auth/hooks/useGetIsUngated';
import { GATE_COPILOT_SALES_ACCESS, GATE_AGENT_AI_STUDIO } from '../constants';
import { useCollaborationParentState } from '../../hooks/useCollaborationParentState';
import { INTERACTIVE_MODE_PLUGIN } from '../../types/PluginTypes';
import { useIsUngatedForCopilotV2 } from './useIsUngatedForCopilotV2';
export const useHasSalesCopilotAccess = () => {
  const isUngated = useGetIsUngated();
  const getHasScope = useGetHasScope();

  /** Product scope for Sales GPT users
   * This scope is added to any user in 53
   * https://private.hubteam.com/atlas-internal/scopes/5835/hubspotters
   */
  const isSalesGPTUser = useMemo(() => {
    return getHasScope('sales-gpt-access');
  }, [getHasScope]);
  const isUngatedForSalesCopilot = useMemo(() => isUngated(GATE_COPILOT_SALES_ACCESS), [isUngated]);
  return isSalesGPTUser && isUngatedForSalesCopilot;
};
export const useIsInteractiveModePluginEnabled = () => {
  const {
    allowedPlugins,
    getParentAppStateByPlugin
  } = useCollaborationParentState();
  const {
    customFEActions
  } = getParentAppStateByPlugin(INTERACTIVE_MODE_PLUGIN) || {};
  // Plugin is enabled and has custom FE actions (if FE are [] will break)
  return allowedPlugins.includes(INTERACTIVE_MODE_PLUGIN) && customFEActions && customFEActions.interactions && customFEActions.interactions.length > 0;
};
export const useHasChatAgentAccess = () => {
  const isUngated = useGetIsUngated();
  const isUngatedForCopilotV2 = useIsUngatedForCopilotV2();
  const isUngatedForChatAgent = useMemo(() => isUngated(GATE_AGENT_AI_STUDIO), [isUngated]);
  /** Chat Agents are only available on Copilot V2 */
  return isUngatedForCopilotV2 && isUngatedForChatAgent;
};